<template>
  <Popover
    v-model="showPopover"
    trigger="click"
    :actions="options"
    @select="onSelect"
    style="width: 100%"
  >
    <template #reference>
      <div class="popover">
        <div class="popover-wrap">
          {{ actionValue }}
          <div class="popover-wrap-icon">
            <template v-if="showPopover">
              <Icon name="play" style="transform: rotate(-0.25turn)" />
            </template>
            <template v-else>
              <Icon name="play" style="transform: rotate(0.25turn)" />
            </template>
          </div>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script>
import { Popover, Grid, GridItem, Icon } from "vant";
export default {
  components: {
    Popover,
    Grid,
    GridItem,
    Icon,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPopover: false,
      actionValue: "",
    };
  },
  methods: {
    onSelect(item) {
      console.log("item", item);
      this.modelValue = item.value;
      // this.actionValue = item.text;
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
  watch: {
    // actionValue(val) {
    //   for (let item of this.options) {
    //     if (item.text === val.text) {
    //       this.modelValue = item.value;
    //     }
    //   }
    // },
    modelValue: {
      handler(val) {
        for (let item of this.options) {
          if (item.value === val) {
            this.actionValue = item.text;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  width: 100%;
  // border: 0.01rem solid #999;
  // padding: 0.02rem;
  // border-radius: 0.5rem;
  &-wrap {
    width: 100%;
    border: 0.01rem solid rgb(172, 185, 231);
    background: rgba(172, 185, 232, 0.4);
    border-radius: 0.5rem;
    padding: 3px;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: absolute;
      width: 25%;
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgb(172, 185, 231);
      border-radius: 0.5rem;
      margin: 0 auto;
      // border: 0.01rem solid #999;
    }
  }
}
</style>

<style lang="scss">
.van-popover {
  padding: 0 5px;
  display: flex;
  justify-content: center;

  .van-popover__arrow {
    display: none;
  }
}
.van-popover--light .van-popover__content {
  border: 1px solid rgb(172, 185, 231);
  max-height: 5rem;
  overflow-y: auto;
  translate: 0 -5%;
  .van-popover__action {
    font-size: 0.2rem;
    border-bottom: 1px dashed rgb(172, 185, 231);
    height: 35px;
    // 最后一个没有
    &:last-child {
      border-bottom: none;
    }
    &:active {
      background: #eee;
    }
  }
}

.van-icon-play:before {
  color: white;
}
</style>
